// extracted by mini-css-extract-plugin
module.exports = {"link":"TextItem__link--overlay--2X_mB","item":"TextItem__item--overlay--2Ccb8","isSubmenuOpen":"TextItem__isSubmenuOpen--overlay--2sI-Q","isActive":"TextItem__isActive--overlay--ZYfcm"};
    if(module.hot) {
      // 1605595234915
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  